import { createAsyncThunk } from '@reduxjs/toolkit';
import { Country } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchCountry, FindCountry, GetCountry } from './interface';

export const findCountry = createAsyncThunk(
  'country/findCountry',
  async (values: FindCountry, { rejectWithValue }) => {
    try {
      const response = await Country.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createCountry = createAsyncThunk(
  'country/createCountry',
  async (values: CreatePatchCountry, { rejectWithValue }) => {
    try {
      const response = await Country.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchCountry = createAsyncThunk(
  'country/patchCountry',
  async ({ id, ...values }: CreatePatchCountry, { rejectWithValue }) => {
    try {
      const response = await Country.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCountry = createAsyncThunk(
  'country/getCountry',
  async ({ id }: GetCountry, { rejectWithValue }) => {
    try {
      const response = await Country.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);